import axios from 'axios'
import dateTimeFormater from '../dateTimeFormater'

const sendVirtualEventDataCreate = (data, host = '') => {

  let onPortal = data.type.toLowerCase() === 'virtual event+' ? false : true

  const getAssets = (data) => {
    let assets: any[] = []
    if (data.keywords) {
      let keywords = {
        type: "keyword",
        value: data.keywords.split(",")
      }
      assets.push(keywords)
    }
    if (data.primaryCommunity) {
      let primaryCommunity = {
        type: "primarySubCommunity",
        value: [data.primaryCommunity]
      }
      assets.push(primaryCommunity)
    }
    if (data.secondaryCommunities) {
      let secondaryCommunities = {
        type: "secondarySubCommunity",
        value: data.secondaryCommunities
      }
      assets.push(secondaryCommunities)
    }

    return assets
  }

  let body: any = {
    accountId: data.accountId,
    accountName: data.accountName,
    title : data.title,
    description : data.description,
    type : data.type,
    onPortal: onPortal,
    timezone : data.timeZone,
    scheduledStartDate: dateTimeFormater(data.startDate, data.startTime, data.timeZone),
    scheduledEndDate :  dateTimeFormater(data.endDate, data.endTime, data.timeZone),
    published : Boolean(data.published),
    assets : getAssets(data),
    visibility: data.visibility
  }

  if (data.type.toLowerCase() !== 'virtual event+') {    
    body.featured = true
    body.community = data.parentCommunity || ''
  }

  return axios.post(`${host}/service/summit/v3/summit`, body ,
    {
      headers: {
        'content-type': 'application/json',
        'accept': 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central',
        withCredentials: true
      }
    }
  )

}

export default sendVirtualEventDataCreate
